import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LicenseInfo } from "@mui/x-license-pro";
import { MuiSnackBarProvider } from "@src/appV2/lib";
import { MuiThemeProvider } from "@src/appV2/lib/Theme";
import { UserPreferencesProvider } from "@src/appV2/UserPreferences/UserPreferencesProvider";
import { environmentConfig } from "@src/appV2/environment";

LicenseInfo.setLicenseKey(environmentConfig.REACT_APP_MUI_LICENSE_KEY);

interface MaterialUiProvidersProps {
  children: React.ReactNode;
}

/**
 * @deprecated For new code, do not wrap in this bundle. It mounts the legacy
 * `MuiThemeProvider` whose breakpoints, spacing, palette, typography, and component
 * overrides diverge from the current design system. Wrap your feature in
 * `BerlinThemeProvider` from `@src/appV2/redesign/theme/ThemeProvider` instead — it
 * uses `ScopedCssBaseline` and is designed to nest inside the root tree, which
 * currently provides `MuiSnackBarProvider` and `LocalizationProvider` via this same
 * `MaterialUiProviders`. Once those are hoisted to `src/index.tsx`, this bundle can
 * be removed.
 */
export function MaterialUiProviders(props: MaterialUiProvidersProps) {
  const { children } = props;
  // Material UI components may require multiple providers to work properly.
  // In this component, all of them are grouped:
  // 1. UserPreferencesProvider for theme mode (light/dark) - must wrap theme provider
  // 2. MuiThemeProvider for theme styling
  // 3. LocalizationProvider for DateRange picker
  // 4. MuiSnackbarProvider for notistack toasts
  return (
    <UserPreferencesProvider>
      <MuiThemeProvider>
        <MuiSnackBarProvider>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            localeText={{
              // ref: https://github.com/mui/mui-x/issues/8526#issuecomment-1499283578
              fieldMonthPlaceholder: (params) => (params.contentType === "letter" ? "MMM" : "MM"),
            }}
          >
            {children}
          </LocalizationProvider>
        </MuiSnackBarProvider>
      </MuiThemeProvider>
    </UserPreferencesProvider>
  );
}
